<template>
<div class="orderList">
  <van-pull-refresh v-model="loading" @refresh="onRefresh">
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="暂无更多数据"
      @load="loadData"
    >
        <div v-if="list && list.length > 0">
          <div v-for="(item, index) in list" :key="index" @click="orderDetail(item)" class="orderConter">
            <div class="header">
              <div class="headerTit">
                <img :src="$route.query.categoryName === '违章' ? orderIcon2 : orderIcon1" alt="">
                <div class="title">{{item.productName}}</div>
              </div>
              <div class="state">{{item.rechargeStatusName}}</div>
            </div>
            <div class="content">
              <van-row>
                <van-col span="6" class="textNo">订单编号</van-col>
                <van-col span="18" class="textVal">{{item.orderNo}}</van-col>
              </van-row>
              <van-row v-if="item.paidTime">
                <van-col span="6" class="textNo">支付时间</van-col>
                <van-col span="18" class="textVal">{{item.paidTime}}</van-col>
              </van-row>
              <van-row>
                <van-col span="6" class="textNo">支付金额</van-col>
                <van-col span="18" class="textVal">{{item.paidPrice}}</van-col>
              </van-row>
            </div>
          </div>
        </div>
        <div v-if="!loading && list.length <= 0" class="noOrder">
          <img src="@/assets/img/ticket/pic_default.png" alt="">
          <!-- <div class="info">暂无数据</div> -->
        </div>
    </van-list>
  </van-pull-refresh>
</div>
</template>
<script>
import { getOrderList } from "@/common/api.js";
export default {
  name: "orderList",
  components: {
  },
  data() {
    return {
      orderIcon1: require("@/assets/img/ticket/orderIcon1.png"),
      orderIcon2: require("@/assets/img/ticket/orderIcon2.png"),
      list: [],
      loading: false,
      finished: false,
      pageNum: 1,
      pageSize: 10
    }
  },
  mounted() {
    this.getOrderList()
  },
  methods: {
    onRefresh() {
      this.pageNum = 1;
      this.list = [];
      this.finished = false;
      this.getOrderList()
    },
    loadData() {
      this.pageNum ++;
      this.getOrderList()
    },
    async getOrderList() {
      this.loading = true
      const data = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        productCategoryCodes: [this.$route.query.categoryCode]
      }
      const res = await getOrderList(data)
      const list = res.list || []
      this.list = [...this.list, ...list]
      // 是否已加载全部数据
      this.finished = this.list.length >= res.total
      this.loading = false
    },
    orderDetail(data) {
      this.$router.push({
          path: this.$route.query.categoryName === '违章' ? '/pvOrderDetail' : '/ticketOrderDetail',
          query: {
            phone: this.$route.query.phone,
            productCode: data.productCode,
            orderNo: data.orderNo
          },
        });
    }
  }
}
</script>
<style scoped lang="scss">
.orderList{
  width: 100%;
  background: #F4F6F7;
  height: 100vh;
  font-size: 0.36rem;
  font-family:'Microsoft YaHei';
  .orderConter{
    background: #fff;
    padding: 0.3rem 0;
    border-top: 0.3rem solid #F4F6F7;
    .header{
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 0.4rem;
      .headerTit{
        display: flex;
      justify-content: space-between;
      align-items: center;
      }
      img{
        width: 0.8rem;
        height: 0.8rem;
        margin-right: 0.2rem;
      }
      .title{
        color: #383838;
        font-weight: 500;
      }
      .state{
        color: #383838;
      }
    }
    .content{
      padding: 0.3rem 0.4rem 0;
      border-top: 1px solid #F4F6F7;
      margin-top: 0.3rem;
      .textNo, .textVal{
        height: 0.8rem;
        line-height: 0.8rem;
      }
      .textNo{
        color: #787878;
      }
      .textVal{
        color: #383838;
      }
    }
  }
  .noOrder{
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    img{
      width: 4rem;
      margin: 3.5rem 0 0.2rem;
    }
    .info{
      width: 100vw;
      color: #787878;
      font-size: 0.32rem;
      text-align: center;
    }
  }
}
</style>